import React, { useState } from "react"
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    FormGroup,
    Label,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardFooter,
    Button,
    Row,
    Col
} from "reactstrap";
import MembersService from "services/staff.service"

import moment from 'moment'

function MemberDetail(props) {
    const data = props.data
    const [id, setId] = useState(data.id || '')
    const [role, setRole] = useState(data.role || '')
    const [account, setAccount] = useState(data.username || '')
    const [email, setEmail] = useState(data.email || '')
    const [fullName, setFullName] = useState(data.fullname || '')
    const [password, setPassword] = useState('')
    const [createdAt, setCreatedAt] = useState(moment(data.createdAt).format('DD/MM/yyyy') || '')
    const [updatedAt, setUpdatedAt] = useState(moment(data.updatedAt).format('DD/MM/yyyy') || '')
    const [passwordEncryption, setPasswordEncryption] = useState(data.password || '')

    function deleteMember() {
        if (role == 'ADMIN') {
            Swal.fire({
                icon: 'error',
                title: 'Thông báo',
                text: 'Bạn không thể xóa tài khoản admin',
            })
        } else {
            Swal.fire({
                title: 'Xác nhận',
                text: 'Bạn có chắc chắn muốn xóa tài khoản này ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Có',
                cancelButtonText: 'Không'
            }).then((result) => {
                if (result.value) {
                    MembersService.deleteMemberByMemberId(id)
                        .then(response => {
                            Swal.fire({
                                icon: 'success',
                                title: 'Thành công',
                                text: response.data.message,
                            }).then(res => {
                                window.location.reload();
                            })
                        }, error => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Lỗi',
                                text: error.message,
                            })
                        })
                };
            })
        }
    }

    function updateMember() {
        Swal.fire({
            title: 'Xác nhận',
            text: 'Bạn có chắc chắn muốn thay đổi thông tin tài khoản này ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Có',
            cancelButtonText: 'Không'
        }).then((result) => {
            if (result.value) {
                MembersService.updateMemberByMemberId(id, memberInformationWillUpdate())
                    .then(response => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Thành công',
                            text: response.data.message,
                        }).then(res => {
                            window.location.reload();
                        })
                    }, error => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Lỗi',
                            text: error.message,
                        })
                    })
            };
        })
    }

    function memberInformationWillUpdate() {
        return {
            "username": account,
            "password": changePassword(password),
            "email": email,
            "fullname": fullName,
        }
    }

    function changePassword(pass) {
        return pass == '' ? passwordEncryption : pass
    }

    return (
        <Row>
            <Col md="12">
                <Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                    <CardHeader style={{ background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', padding: '18px 24px', border: 'none', borderRadius: '20px 20px 0 0', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <i className="fas fa-user" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
                        <div style={{ lineHeight: '1.3' }}>
                            <Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>Chi tiết tài khoản</Label>
                            <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>Thông tin nhân viên</span>
                        </div>
                    </CardHeader>
                    <CardBody style={{ padding: '20px 24px' }}>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="id">Mã người dùng</Label>
                                    <Input
                                        value={id}
                                        id="id"
                                        disabled={true}
                                        onChange={(e) => setId(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="role">Quyền</Label>
                                    <Input
                                        value={role}
                                        id="role"
                                        disabled={true}
                                        onChange={(e) => setRole(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="account">Tài khoản</Label>
                                    <Input
                                        value={account}
                                        id="account"
                                        onChange={(e) => setAccount(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="password">Mật khẩu mới</Label>
                                    <Input
                                        type="password"
                                        value={password}
                                        id="password"
                                        placeholder="Để trống nếu không thay đổi"
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                        type="email"
                                        value={email}
                                        id="email"
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="fullname">Họ và tên</Label>
                                    <Input
                                        value={fullName}
                                        id="fullname"
                                        onChange={(e) => setFullName(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="createdAt">Thời gian tạo</Label>
                                    <Input
                                        value={createdAt}
                                        id="createdAt"
                                        disabled={true}
                                        onChange={(e) => setCreatedAt(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="updatedAt">Cập nhật lần cuối</Label>
                                    <Input
                                        value={updatedAt}
                                        id="updatedAt"
                                        disabled={true}
                                        onChange={(e) => setUpdatedAt(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter style={{ padding: '20px 24px' }}>
                        <Row>
                            <Col className="text-right">
                                <Button color="danger" style={{ borderRadius: '20px', padding: '8px 20px', marginRight: '10px' }} onClick={() => deleteMember()}>
                                    <i className="fas fa-times" /> Xóa
                                </Button>
                                <Button color="primary" style={{ borderRadius: '20px', padding: '8px 20px' }} onClick={() => updateMember()}>
                                    <i className="fas fa-sync-alt" /> Cập nhật
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </Col>
        </Row>
    )
}

export default MemberDetail